module.exports = __webpack_public_path__ + "static/media/10.Foreign Tour.cf3d06b7.jpg";